<template>
  <section class="w-full flex justify-center text-skin-primary-findrisk">
    <section
      class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-x-4 lg:gap-x-6 px-16px lg:px-6 pt-4"
    >
      <section class="col-span-full xl:col-start-2 xl:col-end-12 py-20">
        <section class="w-full flex flex-col items-center">
          <icon
            :width="100"
            :height="82"
            :name="'mensaje'"
            :color="'skin-blueCambiando'"
          />
          <p
            class="text-3xl font-bold pt-12"
            :class="{ 'text-center': isSmallMobile }"
            v-text="'Gracias por cuidar de tu salud'"
          />
          <p
            class="text-lg font-semibold pt-8 px-16px max-w-171 text-center"
            v-text="
              'A continuación, te presentamos el análisis obtenido según tus respuestas. Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
            "
          />
          <section class="pt-12">
            <p
              class="font-bold text-3xl"
              v-text="`Tu índice de masa corporal (IMC) es ${mci}`"
            />
          </section>
        </section>
        <section
          class="w-full mt-12 pt-12 border-t border-skin-check-box grid lg:grid-cols-2 gap-x-4 lg:gap-x-6 gap-y-6"
        >
          <section class="w-full">
            <p
              class="text-3xl font-bold px-16px"
              v-text="
                'Su nivel de riesgo de contraer diabetes (en los próximos 10 años)'
              "
            />
            <section class="bg-skin-check_inactive mt-12 px-16px md:px-8 pb-8">
              <section
                class="w-full flex justify-between items-center px-2.5 py-20px"
              >
                <p
                  class="text-2xl font-bold text-skin-blueCambiando"
                  v-text="riskDescription"
                />
                <article class="flex flex-col items-center">
                  <p class="text-2xl font-bold " v-text="riskPercent" />
                  <div
                    class="w-8 h-2 rounded mt-1"
                    :class="`bg-skin-${riskColor}`"
                  />
                </article>
              </section>
              <section class="px-2.5 pt-6 border-t border-skin-check-box">
                <p
                  class="font-medium px-16px"
                  v-text="currentDescription.mainDescription"
                />
                <section>
                  <ul
                    v-if="currentDescription.rules"
                    class="pl-8 pr-16px md:pl-12 md:pr-8 w-full flex flex-col gap-y-4 pt-6 list-disc"
                  >
                    <li
                      v-for="(descriptionItem,
                      index) in currentDescription.rules"
                      :key="index"
                      v-text="descriptionItem"
                    />
                  </ul>
                </section>
              </section>
            </section>
          </section>
          <section class="w-full">
            <p
              class="text-3xl font-bold px-16px pb-6"
              v-text="'Usted puede disminuir el riesgo de la siguiente forma'"
            />
            <section
              class="md:px-16px pt-6 md:h-screen--150 overflow-y-auto md:min-h-150 light-scroll"
            >
              <container-text-description
                :title="'Comer y beber de forma saludable'"
                :items="riskReductionItems[0]"
                :iconWidth="40"
                :iconHeight="35"
                :iconName="'comida_saludable'"
              />
              <container-text-description
                class="pt-16"
                :title="'Más ejercicio en su vida contidiana '"
                :items="riskReductionItems[1]"
                :iconWidth="40"
                :iconHeight="40"
                :iconName="'ejercicio'"
              />
              <container-text-description
                class="pt-16"
                :title="'Manténgase activo permanentemente'"
                :items="riskReductionItems[2]"
                :iconWidth="40"
                :iconHeight="35"
                :iconName="'comida_saludable'"
              />
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import utilsMixin from "../../mixins/utilsMixin";
export default {
  beforeMount() {
    this.showResults = this.$route.params.showResults ? true : false;
    if (!this.showResults) this.$router.push({ name: "find-risk" });
    this.total = this.$route.params.total;
    this.mci = this.$route.params.mci;

    if (localStorage.getItem("birthdate")) localStorage.removeItem("birthdate");
    if (localStorage.getItem("genre")) localStorage.removeItem("genre");
    if (localStorage.getItem("size"))
      this.size = localStorage.removeItem("size");
    if (localStorage.getItem("weight")) localStorage.removeItem("weight");
    if (localStorage.getItem("age")) localStorage.removeItem("age");
    if (localStorage.getItem("familyBackground"))
      localStorage.removeItem("familyBackground");
    if (localStorage.getItem("weistPerimeter"))
      localStorage.removeItem("weistPerimeter");
    if (localStorage.getItem("physicalActivity"))
      localStorage.removeItem("physicalActivity");
    if (localStorage.getItem("healthyFoodConsumptionFrecuency"))
      localStorage.removeItem("healthyFoodConsumptionFrecuency");
    if (localStorage.getItem("hypertensionMedicines"))
      localStorage.removeItem("hypertensionMedicines");
    if (localStorage.getItem("bloodGlucose"))
      localStorage.removeItem("bloodGlucose");
  },
  mixins: [utilsMixin],
  components: {
    ContainerTextDescription: () => import("../ContainerTextDescription.vue"),
    Icon: () => import("../Icon.vue"),
  },
  data: () => ({
    showResults: false,
    mci: 0,
    total: 0,
    descriptionItems: [
      {
        mainDescription:
          "Su nivel de riesgo es muy bajo. En su caso no es  necesario un cuidado especial o de prevención. Sin  embargo no estaría mal cuidar de su alimentación y  realizar suficiente ejercicio.",
      },
      {
        mainDescription:
          "Para usted es recomendable un poco de cuidado, aunque  el nivel de riesgo de contraer una diabetes no es muy alto.  Si quiere ir sobre seguro, siga las siguientes reglas:",
        rules: [
          "En el caso de sobrepeso deberá intentar disminuir su peso en un 7 por ciento",
          "Manténgase en actividad, por lo menos, por media hora durante cinco días a la semana ",
          "La grasa debería constituir, como máximo, sólo un 30 por ciento de su alimentación ",
          "La parte de ácidos grasos no saturados (sobre todo en la grasa animal) no debería sobrepasar del 10 por ciento en su alimentación ",
          "Consuma diariamente, por lo menos, 30 gramos de fibras vegetales (como las contenidas en productos integrales, verduras y frutas)",
        ],
      },
      {
        mainDescription:
          "Si usted se encuentra en este grupo de riesgo, no debería postergar, por ningún motivo, el tomar medidas preventivas. En este caso lo pueden ayudar consejos e instrucciones de expertos para cambiar su estilo de vida, los cuales puede aplicarlos usted mismo. Recurra a ayuda profesional si nota que de esa manera no se puede ayudar. ",
      },
      {
        mainDescription:
          "Su nivel de riesgo es muy alto: una tercera parte de los  pacientes que corresponden a este grupo de riesgo  contraen diabetes en los próximos 10 años. El subestimar  esta situación puede traer graves consecuencias. Lo mejor sería recurrir a ayuda profesional. Haga una prueba  de glucemia (azúcar en la sangre) en una farmacia y vaya a hacerse exámenes médicos. (checkup a partir de los 35)",
      },
      {
        mainDescription:
          "Existe la necesidad de actuar inmediatamente, ya que  es muy posible que usted ya sufra de diabetes. Eso pasa  con el 35 por ciento de las personas que se encuentran  sobre los 20 puntos. Una simple prueba de glucemia en  su farmacia más cercana, por ejemplo, puede servir de  ayuda como una información adicional. De todas formas,  ésta no reemplaza un diagnóstico del laboratorio para  descartar una diabetes ya existente. Por esta razón  debería solicitar una consulta médica, inmediatamente.",
      },
    ],
    riskReductionItems: [
      [
        {
          title: "Más fruta y verdura",
          description:
            "Todos sus alimentos deben contener, en lo posible, mucha fruta y verdura. Lo ideal es que aplaque su hambre solamente con estos alimentos",
        },
        {
          title: "Alimentos  pobres en  grasas",
          description:
            "Al comprar productos lácteos elija las variantes con  poca grasa. Coma carnes y embutidos magros pero  con moderación. Por lo menos una vez por semana  coma pescado. ",
        },
        {
          title: "Cocinar con  poca grasa ",
          description:
            "Utilize sartenes con recubrimiento antiadherente, así se puede evitar el uso de mucho aceite al  freir. En la cocina los aceites grasos deben ser  sustituídos,principalmente, por el aceite de colza  (al freir) y el aceite de oliva (en las ensaldas).",
        },
        {
          title: "Bocadillos  saludables ",
          description:
            "La comida rápida (fastfood) y la ya elaborada son  bombas de calorías. Renuncie a ellas. La naturaleza le  ofrece ricos productos para las comidas entre horas  como: uvas, zanahorias o manzanas.",
        },
        {
          title: "Bebidas saludables",
          description:
            "Evite las bebidas que contienen azúcar. Aplaque su  sed con agua mineral, zumos de frutas o té de hierbas.",
        },
      ],
      [
        {
          title: "Tómese tiempo:",
          description:
            "Haga ejercicio diariamente por 30 o 60 minutos. Elija actividades que pueda acomodar en su vida cotidiana.",
        },
        {
          title: "Use el camino  al trabajo como  entrenamiento ",
          description:
            "Use, por ejemplo, el tiempo de espera en la parada  de autobus y tense los glúteos y luego los músculos  del estómago, alternativamente. Después balancéese  sobre los dedos del pie, subiendo y bajando. Talvéz  le alcance el tiempo incluso para ir a pie hasta la  próxima parada.",
        },
        {
          title: "Prefiera la bicicleta",
          description:
            "Para hacer gestiones en las cercanías use la bicicleta.  Colóquela en un lugar a su alcance, de tal manera que  la pueda usar en cualquier momento y manténgala  apta para funcionar. ",
        },
        {
          title: "Pruebe con la  dinámica de  grupo",
          description:
            "Si le gusta hacer deporte en grupo, aprovéchelo.  El establecer horas fijas para el deporte y el tener  compañeros simpaticos puede ayudar a mantener la  motivación en momentos de desánimo. ",
        },
        {
          title: "Los ejercicios  correctos",
          description:
            "Escoja tipos de deporte con una intensidad  leve hasta media de esfuerzo. El Nordic-Walking, por  ejemplo es un deporte ideal. Si usted suda levemente  y puede conversar bién durante la práctica del depor te, entonces el esfuerzo que hace es el correcto. ",
        },
      ],
      [
        {
          title: "Fíjese objetivos realistas",
          description:
            "Objetivos que no son fáciles de lograr, nos hacen tener mala conciencia y nos desmotivan",
        },
        {
          title: "Introducir días de acción",
          description:
            "De una a 3 veces por año debería crear condiciones claras, rompiendo costumbres antiguas y ordenando su casa radicalmente. Esto vale para el refrigerador así como para el sótano y la sala. Cárguese de fuerza y energía para otros campos de la vida",
        },
        {
          title: "Engáñese a si mismo",
          description:
            "Solamente las medidas que son fáciles de cumplir, pueden mantenerse en la vida cotidiana. Por ejemplo: las zapatillas de deporte que están en el corredor, serán, probablemente, también usadas. Lo mismo sucede con el contenido del refrigerador. Los alimentos saludables coloquelos bien adelante ya que están más al alcance y son los primeros que se toman!",
        },
      ],
    ],
  }),
  methods: {},
  computed: {
    currentDescription() {
      if (this.total >= 7 && this.total <= 11) return this.descriptionItems[1];
      if (this.total >= 12 && this.total <= 14) return this.descriptionItems[2];
      if (this.total >= 15 && this.total <= 20) return this.descriptionItems[3];
      if (this.total > 20) return this.descriptionItems[4];

      return this.descriptionItems[0];
    },
    riskColor() {
      if (this.total >= 7 && this.total <= 11) return "lime-cambiando";
      if (this.total >= 12 && this.total <= 14) return "yellow-cambiando";
      if (this.total >= 15 && this.total <= 20) return "orange-cambiando";
      if (this.total > 20) return "red-cambiando";

      return "green-cambiando";
    },
    riskPercent() {
      if (this.total >= 7 && this.total <= 11) return "4%";
      if (this.total >= 12 && this.total <= 14) return "17%";
      if (this.total >= 15 && this.total <= 20) return "33%";
      if (this.total > 20) return "50%";

      return "1%";
    },
    riskDescription() {
      if (this.total >= 7 && this.total <= 11) return "De 7 a 11 puntos";
      if (this.total >= 12 && this.total <= 14) return "De 12 a 14 puntos";
      if (this.total >= 15 && this.total <= 20) return "De 15 a 20 puntos";
      if (this.total > 20) return "Más de 20 puntos";

      return "Menos de 7 puntos";
    },
  },
};
</script>
